import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

/**
 * Memory → Social publication bridge (TRAVEL-MEMORY-BE-2).
 * Must call Memory social-publications endpoint — never the Social create endpoint from Journal FE.
 */
function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:journeyId|memoryEntryId|authorMemberId|memberId|socialPostId|sourceMemoryEntryId|sourceJourneyId|linkedJourneyPublicationId|publicationId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

export const memorySocialPublicationApi = {
  publish: (journeyId, memoryEntryId, body) => travelClient.post(
    travelEndpoints.journeyMemorySocialPublications(journeyId, memoryEntryId),
    body,
    snowflakeJson,
  ),
};
